(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
